import styled from 'styled-components';

import {
  getThemeColor,
  getThemePath,
  getThemeTransition,
  media,
} from '@utils/styled';

import Typography from '@common/components/Typography';

export const Wrapper = styled.div`
  display: flex;
  ${({ theme }) => theme.getFluidAttribute('gap', 3.5, 6)};

  ${media.from800down`
    flex-direction: column;
  `}
`;

export const CountSticky = styled.div`
  flex: 1;

  ${media.from800up`
    position: sticky;
    align-self: flex-start;
    ${({ theme }) => theme.getFluidSpacing('margin-top', 'equal', 3, true)};
    ${({ theme }) => theme.getFluidSpacing('padding-top', 'equal', 3)};
    transition: ${({ shouldAnimate }) => shouldAnimate && getThemeTransition('top', 'fast')};
  `}
`;

export const CountContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: ${getThemePath(['borderRadiuses', 'normal.2'])}rem;
  ${({ theme }) => theme.getFluidSpacing('padding-top', 'scale', 3)}
  ${({ theme }) => theme.getFluidSpacing('padding-bottom', 'scale', 3)}
  background-color: ${getThemeColor('bluegrey.95')};
`;

export const Count = styled(Typography).attrs({ variant: 'h1' })`
  margin: 0;
`;

export const CountLabel = styled(Typography).attrs({ variant: 'paragraph1' })`
  ${({ theme }) => theme.getFluidAttribute('margin-top', -0.5, -1)};
  color: ${getThemeColor('bluegrey.70')};
  font-weight: 500;
`;

export const CardsWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  border-top: 1px solid ${getThemeColor('bluegrey.90')};
`;
